/**
 * ALBION系ブランド共通カウンセリングモーダル
 * data-brand="albion" data-input-type="checkbox" で ALBION / ELEGANCE / IGNIS / IGNIS iO に対応
 */
if (!customElements.get('my-dialog-albion')) {
class MyDialog extends HTMLElement {
  constructor() {
    super();
    this.activePageIndex = 0;
    this.pendingForm = null;
    this.pendingSubmitButton = null;
    this.dialog = this.querySelector('dialog');
    if (this.dialog && typeof dialogPolyfill !== 'undefined') {
      dialogPolyfill.registerDialog(this.dialog);
    }
    this.pages = this.querySelectorAll('.page');
    this.closeButtons = this.querySelectorAll('.close-button');
    this.nextPageButton = this.querySelector('.next-page');
    this.useCheckbox = this.getAttribute('data-input-type') === 'checkbox';
    this.checkboxes = this.useCheckbox
      ? [
          this.querySelector('input[type="checkbox"][name^="q1"]'),
          this.querySelector('input[type="checkbox"][name^="q2"]'),
          this.querySelector('input[type="checkbox"][name^="q3"]')
        ].filter(Boolean)
      : [];
    this.counselingResult = this.querySelectorAll('.counseling-result');
    this.submitButtons = this.querySelectorAll('button[type="submit"]');
    this.brand = this.getAttribute('data-brand') || 'albion';
  }

  connectedCallback() {
    if (!this.dialog) return;

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) {
        this.clearPendingForm();
        this.dialog.close();
      }
    });

    this.submitButtons.forEach((submitButton) => {
      submitButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.dialog.close();
        if (this.pendingForm && this.pendingSubmitButton) {
          if (this.pendingForm.requestSubmit) {
            this.pendingForm.requestSubmit();
          } else {
            this.pendingForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
          this.clearPendingForm();
        } else {
          const productForm = this.closest('product-form');
          if (productForm) {
            const form = productForm.querySelector('form[data-type="add-to-cart-form"]');
            if (form && form.requestSubmit) {
              form.requestSubmit();
            }
          }
        }
      });
    });

    this.closeButtons.forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        this.clearPendingForm();
        this.dialog.close();
      });
    });

    this.retryButtons = this.querySelectorAll('.retry-counseling');
    this.retryButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.pages.forEach((p, i) => p.classList.toggle('active', i === 0));
        this.activePageIndex = 0;
        if (this.useCheckbox && this.checkboxes.length === 3) {
          this.checkboxes.forEach((cb) => { cb.checked = false; });
        }
        this.checkNextButtonActive();
        this.dialog.scrollTop = 0;
      });
    });

    if (this.nextPageButton) {
      this.nextPageButton.addEventListener('click', () => this.nextPage());
    }

    if (this.pages.length > 0) {
      this.pages[this.activePageIndex].classList.add('active');
    }

    if (this.useCheckbox && this.checkboxes.length === 3) {
      this.checkboxes.forEach((cb) => {
        cb.addEventListener('change', () => this.checkNextButtonActive());
      });
      this.checkNextButtonActive();
    }
  }

  clearPendingForm() {
    this.pendingForm = null;
    this.pendingSubmitButton = null;
  }

  checkNextButtonActive() {
    if (this.useCheckbox && this.checkboxes.length === 3) {
      if (this.nextPageButton) {
        // Albion counseling needs to allow the user to proceed even with no checks
        // so the "cannot sell" result can be displayed.
        this.nextPageButton.disabled = false;
        this.nextPageButton.setAttribute('aria-disabled', 'false');
      }
    }
  }

  openDialog() {
    this.activePageIndex = 0;
    this.pages.forEach((page, index) => page.classList.toggle('active', index === 0));
    this.checkboxes.forEach((input) => { input.checked = false; });
    this.counselingResult.forEach((result) => result.classList.remove('active'));
    if (this.dialog) {
      this.dialog.showModal();
      this.dialog.focus({ preventScroll: true });
      this.dialog.scrollTop = 0;
    }
  }

  nextPage() {
    if (this.activePageIndex + 1 < this.pages.length) {
      this.updateSecondPage();
      this.pages[this.activePageIndex].classList.remove('active');
      this.activePageIndex++;
      this.pages[this.activePageIndex].classList.add('active');
      this.dialog.scrollTop = 0;
      window.BishodoCounseling.recordResult(this);
    }
  }

  updateSecondPage() {
    let q1Value, q2Value, q3Value;
    if (this.useCheckbox && this.checkboxes.length === 3) {
      q1Value = this.checkboxes[0].checked ? 1 : 0;
      q2Value = this.checkboxes[1].checked ? 1 : 0;
      q3Value = this.checkboxes[2].checked ? 1 : 0;
    } else return;

    this.counselingResult.forEach((r) => r.classList.remove('active'));
    const resultIndex = this.getResultIndex(q1Value, q2Value, q3Value);
    if (this.counselingResult[resultIndex]) {
      this.counselingResult[resultIndex].classList.add('active');
    }
  }

  getResultIndex(q1, q2, q3) {
    if (this.brand === 'albion') {
      if (q1 === 1 && q2 === 1 && q3 === 1) return 0;
      if (q1 === 1 && (q2 === 0 || q3 === 0)) return 1;
      return 2;
    }
    return 0;
  }
}

customElements.define('my-dialog-albion', MyDialog);
}
